import PieChartButton from './PieChartButton.connect';

export default PieChartButton;
